import React, { Fragment } from 'react';
import { Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import flatten from 'lodash/flatten';
import PropTypes from 'prop-types';

export default function ErrorAlert({ hasErrors, errorMessages }) {
  const formattedErrors = Array.isArray(errorMessages) ? errorMessages : flatten(Object.values(errorMessages));

  return (
    hasErrors && (
      <Fragment>
        <Alert bsStyle="danger" className="mb-5 d-flex error-container">
          <FontAwesomeIcon icon={faExclamationCircle} size="2xl"/>
          <div className="mt-1 ml-4">
            <h4 className="mt-0">
              The following errors occurred when trying to save this form. Please fix and re-submit.
            </h4>
            <ul>
              {formattedErrors.map((errorMessage, index) => (
                <li key={index}><div>{errorMessage}</div></li>
              ))}
            </ul>
          </div>
        </Alert>
      </Fragment>
    )
  );
}

ErrorAlert.propTypes = {
  errorMessages: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array
  ]),
  hasErrors: PropTypes.bool.isRequired
};
